<script setup lang="ts">
import type { HTMLAttributes } from "vue";

import { cn } from "@shared/lib/utils";
import { useVModel } from "@vueuse/core";

const props = defineProps<{
  class?: HTMLAttributes["class"];
  defaultValue?: number | string;
  modelValue?: number | string;
}>();

const emits = defineEmits<(_e: "update:modelValue", _payload: number | string) => void>();

const modelValue = useVModel(props, "modelValue", emits, {
  defaultValue: props.defaultValue,
  passive: true,
});
</script>

<template>
  <input
    v-model="modelValue"
    :class="
      cn(
        'flex h-9 max-h-9 min-h-9 w-full rounded-md border border-input bg-background px-3 py-2 !text-content file:border-0 file:bg-transparent file:!text-content file:font-medium placeholder:!text-content placeholder:uppercase placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        props.class,
      )
    "
  />
</template>
